/* 🤖 this file was generated by svg-to-ts */
export const mgcIconUpFilled: {
  name: 'up-filled';
  data: string;
} = {
  name: 'up-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.516 7.577a2.31 2.31 0 0 0-.32.163c-.097.059-1.502 1.434-3.122 3.054-2.385 2.385-2.966 2.987-3.053 3.16a1.513 1.513 0 0 0 .3 1.783c.358.335.795.467 1.271.384.509-.089.487-.069 3.038-2.614L12 11.143l2.37 2.364c1.836 1.831 2.416 2.387 2.574 2.466.616.309 1.341.19 1.793-.294.336-.359.469-.804.383-1.28-.093-.513-.025-.436-3.234-3.641-3.403-3.399-3.179-3.211-3.846-3.227-.246-.006-.431.01-.524.046"/></svg>`
};
